var _excluded = ["children", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * done
 */
import React from 'react';
import { wrapReactionHook } from "../../hooks";
import { useCssInJs } from "../../hooks";
import cx from 'classnames';
import { useField } from '@formily/react';
import { genFormSectionStyle } from "./styles";
export var FormSection = wrapReactionHook(function (props) {
  var children = props.children,
    className = props.className,
    rest = _objectWithoutProperties(props, _excluded);
  var prefix = 'form-section';
  var _useCssInJs = useCssInJs({
      prefix: prefix,
      styleFun: genFormSectionStyle
    }),
    wrapSSR = _useCssInJs.wrapSSR,
    hashId = _useCssInJs.hashId;
  var field = useField();
  var title = field.title;
  return wrapSSR( /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    className: cx(hashId, prefix, className)
  }), title ? /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, "".concat(prefix, "-title"))
  }, title) : null, /*#__PURE__*/React.createElement("div", {
    className: cx(hashId, "".concat(prefix, "-content"))
  }, children)));
});